module.exports = __webpack_public_path__ + "img/card_franchise1.d7b6f9d6.svg";